import * as PIXI from 'pixi.js'

import Rectangle from '../../utils/Rectangle'

import Borders from './Borders'
import CanvasDrawer from './CanvasDrawer/CanvasDrawer'
import GraphicsDrawer from './GraphicsDrawer'

export default class Div extends PIXI.Container {
  constructor(sharedResourceId) {
    super()
    this.layout = {
      width: 0,
      height: 0,
      boundingRect: new Rectangle(0, 0, 0, 0),
    }

    this.background = new PIXI.Container()
    this.background.name = `$mudra.background`
    this.background.interactiveChildren = false
    this.addChild(this.background)
    this.graphicsDrawer = new GraphicsDrawer()
    this.canvasDrawer = this.createCanvasDrawer(sharedResourceId)
    this.drawStyle = null
    this.drawWidth = null
    this.drawHeight = null
    this._sharedResourceId = sharedResourceId
  }

  get sharedResourceId() {
    return this._sharedResourceId
  }

  set sharedResourceId(value) {
    if (value !== this._sharedResourceId) {
      this._sharedResourceId = value
      this.canvasDrawer.destroy()
      this.canvasDrawer = this.createCanvasDrawer(this._sharedResourceId)
    }
  }

  createCanvasDrawer(sharedResourceId) {
    const canvasDrawer = new CanvasDrawer(sharedResourceId)
    // Re-emit load event of CanvasDrawer to provide external API for backgroundImage load handling
    canvasDrawer.on('load', () => {
      this.emit('load')
    })

    return canvasDrawer
  }
  /**
   * Layouter API realisation to draw background after layout
   */
  onLayoutCompleted({ style, boundingRect }) {
    this.layout.boundingRect = boundingRect
    const { width, height } = this.layout

    if (this.drawStyle === style && this.drawWidth === width && this.drawHeight === height) {
      return
    }

    this.draw(style, width, height)
    this.drawStyle = style
    this.drawWidth = width
    this.drawHeight = height
  }

  /**
   * Layouter API realisation to store layout size and use it for background drawing
   */
  setLayoutSize(dimension, value) {
    this.layout[dimension] = value
  }

  setDrawer(drawer) {
    this.background.removeChildren()
    const elements =
      typeof drawer.getElements === 'function' ? drawer.getElements() : [drawer.getElement()]
    for (const element of elements) {
      this.background.addChild(element)
    }
    this.currentDrawer = drawer
  }

  chooseDrawer(style) {
    const borders = new Borders(style)
    if (!borders.isSameAppearance()) {
      return this.graphicsDrawer
    }

    return this.canvasDrawer
  }

  draw(style, width, height) {
    const choosedDrawer = this.chooseDrawer(style)
    if (choosedDrawer !== this.currentDrawer) {
      this.setDrawer(choosedDrawer)
    }
    this.currentDrawer.draw(style, width, height)
    if (style.backgroundAlpha != null) {
      this.background.alpha = style.backgroundAlpha
    }
    this.background.hitArea = new PIXI.Rectangle(0, 0, width, height)

    const opacity = typeof style.opacity === 'number' ? style.opacity : 1.0
    if (this.alpha !== opacity) {
      this.alpha = opacity
    }
  }

  destroy(options) {
    super.destroy(options)
    // Because only currentDrawer elements are placed in PIXI tree, we should destroy
    // all drawers manually
    this.canvasDrawer.destroy()
    this.graphicsDrawer.destroy()
    this.draw = () => {}
  }
}
